module.exports = __webpack_public_path__ + "static/InteractiveTelCRMDMSIntegrated-6fd9eaeb0a9d88993faf1737f15ebae3.pdf";